import { render } from "./SystemEspecificAccess.vue?vue&type=template&id=3d7fce16"
import script from "./SystemEspecificAccess.vue?vue&type=script&lang=js"
export * from "./SystemEspecificAccess.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__